import axios from "axios";

const instance = axios.create({
    baseURL: "/api/v1",
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

// Contact form
export const contact = (data) => instance.post("/contact-form", data);

// Commercial projects
// Prices
export const commercialPrices = (params) =>
    instance.get("/commercial-prices", { params });

// Booking
export const commercialBooking = (data) =>
    instance.post("commercial-booking", data);

// Tour registration
export const tourRegistration = (data) =>
    instance.post("/tour-registration-form", data);

// Summer fest registration
export const summerFestRegistration = (data) =>
    instance.post("/festival-registration", data);
export const summerFestRegistrationSecond = (data) =>
    instance.post("/festival-registration/second", data);

// Good host
export const questions = () => instance.get("/good-host/questions");
export const goodHostRegister = (data) => instance.post("/good-host", data);

// URL shortener
export const shorten = (data) => instance.post("/shorten", data);

// QR generator
export const generate = (data) => instance.post("/generate", data);

// Hiking festival
export const hikingFestRegister = (data) =>
    instance.post("/hiking-festival", data);
export const fileUpload = (data) =>
    instance.post("/hiking-festival/upload", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
